import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  inputs: ['dialog']
})
export class DialogComponent implements OnInit {
  public dialog: any;
  @ViewChild("content") model: any;
  constructor(
    private userService: UserService,
    private modalService: NgbModal) {


  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/dialog/dialog.component.ts